import { signal, Type } from "@angular/core";
import { waitForPublicSettings } from "src/standard/services/waitForPublicSettings";

export const navContent$ = signal<{
  state: "pending" | "loading" | "idle";
  content: Type<unknown> | undefined;
}>({
  state: "pending",
  content: undefined,
});

export async function tryStartLoadingNavContent() {
  if (navContent$().state !== "pending") {
    return;
  }

  await waitForPublicSettings();

  navContent$.set({
    state: "loading",
    content: undefined,
  });

  // Start fetching nav content in parallel
  void import("src/app/nav-content/nav-content.component")
    .then((res) => {
      navContent$.set({
        state: "idle",
        content: res.default,
      });
    })
    .catch((err: unknown) => {
      // Set back to pending
      navContent$.set({
        state: "pending",
        content: undefined,
      });
    });
}
